import React, { useState, useEffect, useCallback } from "react";
import Layout from "containers/LayoutV2";
import ThongKeApi from "service/ThongKe/ThongKeApi";
import { SearchBarDestop } from "./SearchBarDestop";
import { SummarySection } from "./SummarySection";
import { TableDanhSach } from "./ChiTiet/TableDanhSach";
import { pushNotification } from "utils/notifications";
import StoreApi from "service/phanQuyenApi";
import configsRole from "utils/configsRole";
import { format } from "date-fns";
import UserApi from "service/userApi";

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;

const buildApiParams = (filters) => {
  const submissionFilters = { ...filters };
  if (
    submissionFilters.month > 0 &&
    submissionFilters.year > 0 &&
    !submissionFilters.dtFrom &&
    !submissionFilters.dtTo
  ) {
    const year = submissionFilters.year;
    const month = submissionFilters.month;
    submissionFilters.dtFrom = null;
    submissionFilters.dtTo = new Date(year, month, 0);
  }
  return {
    dtFrom: submissionFilters.dtFrom
      ? format(submissionFilters.dtFrom, "dd/MM/yyyy")
      : null,
    dtTo: submissionFilters.dtTo
      ? format(submissionFilters.dtTo, "dd/MM/yyyy")
      : null,
    CustomerName: submissionFilters.customerName,
    PhoneNumber: submissionFilters.phoneNumber,
    IdentifierCode: submissionFilters.identifierCode,
    ContractCode: submissionFilters.contractCode,
  };
};

const initialFiltersState = {
  year: currentYear,
  month: currentMonth,
  dtFrom: null,
  dtTo: null,
  customerName: "",
  phoneNumber: "",
  identifierCode: "",
  contractCode: "",
};
const initialSummaryData = {
  TongThuGocDuKien: 0,
  TongThuLaiDuKien: 0,
  TongThuPhiHangKyDuKien: 0,
};
const initPhanQuyen = {
  thudukien: false,
};

export const ThongKeThuDuKien = () => {
  const [filters, setFilters] = useState(initialFiltersState);
  const [filterParams, setFilterParams] = useState(buildApiParams(filters));
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const [loading, setLoading] = useState(true);
  const [loadingData, setLoadingData] = useState({ summary: true });
  const [summaryData, setSummaryData] = useState(initialSummaryData);
  const [modalState, setModalState] = useState({
    show: false,
    type: "",
    title: "",
  });

  const LoadPhanQuyen = () => {
    setLoading(true);
    StoreApi.getAllQuyen()
      .then((response) => {
        if (response.status === 200) {
          const getRole = (code) =>
            response.data.some(
              (e) => e.ModuleCode?.toUpperCase() === code.toUpperCase()
            );
          setPhanQuyen({
            thudukien: getRole(configsRole.sRole.thudukien),
          });
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    document.title = "Thống kê thu dự kiến | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
  }, []);

  const fetchData = useCallback(() => {
    setLoadingData((prev) => ({ ...prev, summary: true }));
    const summaryPromise = ThongKeApi.getThuDuKienSummary(
      buildApiParams(filters)
    );
    Promise.all([summaryPromise])
      .then(([summaryRes]) => {
        setSummaryData(summaryRes.data || initialSummaryData);
      })
      .catch(() => {
        pushNotification("Tải dữ liệu thống kê thất bại!", "error");
        setSummaryData(initialSummaryData);
      })
      .finally(() => setLoadingData((prev) => ({ ...prev, summary: false })));
  }, [filters]);

  useEffect(() => {
    if (phanQuyen.thudukien) {
      fetchData();
    }
  }, [phanQuyen.thudukien, fetchData]);

  const handleApplyFilter = (newFilters) => {
    setFilters(newFilters);
    setFilterParams(buildApiParams(newFilters));
  };

  const handleSummaryClick = (type, title) => {
    setModalState({ show: true, type, title });
  };

  // if (loading) return null; loi menu

  return (
    <Layout>
      {phanQuyen.thudukien === true ? (
        <>
          <div id="form-repeater" className="p-2">
            <div className="row header justify-content-start mb-1 ml-1">
              <img
                src="/app-assets/images/icon-thong-ke.png"
                alt="Mẫu hợp đồng"
              />
              <h1 className="text-info-home">Thống Kê Thu Dự Kiến</h1>
            </div>

            <div className="card border-light mb-1 card-v2">
              <div className="card-body card-body-v2">
                {loadingData.config ? (
                  <div className="text-center p-5">Đang tải cấu hình...</div>
                ) : (
                  <SearchBarDestop
                    initialFilters={filters}
                    onApply={handleApplyFilter}
                  />
                )}
              </div>
            </div>

            <div className="card border-light mb-1 card-v2">
              <div className="card-body card-body-v2">
                <SummarySection
                  data={summaryData}
                  loading={loadingData.summary}
                  onItemClick={handleSummaryClick}
                />
              </div>
            </div>
          </div>

          {modalState.show && (
            <TableDanhSach
              show={modalState.show}
              onHide={() => setModalState({ ...modalState, show: false })}
              type={modalState.type}
              title={modalState.title}
              filters={filterParams}
            />
          )}
        </>
      ) : (
        <div className="p-2">
          <div className="d-flex align-items-center mb-1 ml-1">
            <img
              src="/app-assets/images/icon-thong-ke.png"
              alt="Mẫu hợp đồng"
            />
            <h1 className="text-info-home mb-0 ms-2 fw-bold">
              Thống Kê Thu Dự Kiến
            </h1>
          </div>
          <div className="card border-light mb-1 card-v2">
            <div className="card-body card-body-v2 text-center text-danger">
              Bạn không có quyền truy cập chức năng này.
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};
